import React from "react";
import uniqueId from 'lodash/uniqueId';
import { Modal, Button, Table } from "react-bootstrap";
import { currencyFormat } from "shared/components/helpers";

function AccountHistoryLayout(props) {
  return (
    <div>
      <Modal
        show={props.show}
        onHide={() => props.handleShow("AccountHistory", false)}
        bsSize="large"
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-primary">Account History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>{props.currentPlan.provider}</h4>
          {props.accountHistory ? (
            <Table striped bordered condensed hover responsive>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Description</th>
                  <th>Payment Method</th>
                  <th>Status</th>
                  <th>Balance</th>
                </tr>
              </thead>
              <tbody>
                {props.accountHistory.map(history => (
                  <tr key={uniqueId(history.confirmationId)}>
                    <td>{history.date}</td>
                    <td>{currencyFormat(history.amount)}</td>
                    <td>{history.activity}</td>
                    <td>{history.paymentMethod}</td>
                    <td>{history.status}</td>
                    <td>{currencyFormat(history.balance)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : null}
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-warning"
            onClick={() => props.handleShow("AccountHistory", false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default AccountHistoryLayout;



// WEBPACK FOOTER //
// ./src/home/components/account-history-layout.js